/*  ==========================================================================
    TEXT PIC BOX V4
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';

/*
 * MODULE
 */

export function initTextPicBoxV4($element) {

    // magnific popup
    utils.mfp.initGallery($element);

}


// WEBPACK FOOTER //
// ./source/js/modules/lib/text-pic-box-v4.js